import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Animacao } from '../../core/tools/animacao';
import { ToastrService } from 'ngx-toastr';
import { ExcelService } from '../../core/tools/excel.service';

/* Services */

import { VendedorService } from '../../core/services/vendedores/vendedor.service';

/* Models */

import { Vendedor } from '../../core/models/vendedores/vendedor';
import { VendedorResumoLicencas } from '../../core/models/vendedores/vendedor-resumo-licencas';

@Component({
    selector: 'app-vendedores',
    templateUrl: './vendedores.component.html',
    styleUrls: ['./vendedores.component.css'],
    preserveWhitespaces: false,
    animations: [Animacao],
    standalone: false
})

export class VendedoresComponent implements OnInit {
  /* Carregamento */

  carregando: boolean = false;

  /* Filtros */

  formFiltro: UntypedFormGroup;

  enviado: boolean = false;
  filtrado: boolean = false;
  ordemUltimoLogin: 'asc' | 'desc' = null;

  /* Vendedores */

  vendedores: Vendedor[] = [];
  vendedoresOriginal: Vendedor[] = [];

  /* Storage */

  is_master: boolean = (localStorage.getItem("is_master") == "true");
  is_diretor: boolean = (localStorage.getItem("is_diretor") == "true");
  flag_gerencia_permissoes: boolean = (localStorage.getItem("flag_gerencia_permissoes") == "true");

  /* Resumo de Licenças */

  resumoLicencas: VendedorResumoLicencas = null;
  carregandoResumoLicencas: boolean = false;
  tipoLicencaExpandido: string = null;
  outrasCobrancasExpandido: boolean = false;

  constructor(
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    private toastr: ToastrService,
    private excelService: ExcelService,
    private vendedorService: VendedorService,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    /* Filtros */

    this.formFiltro = this.formBuilder.group({
      nome: [""],
      somenteComVersao: [false]
    });

    this.carregarDados();
  }

  get f() {
    return this.formFiltro.controls;
  }

  /* Ações */

  alterarVendedor(id: number) {
    this.router.navigate(["/vendedores-cadastro/" + id]);
  }

  resetarSenha(id: number) {
    let alterarSenha: boolean = false;

    this.vendedorService.updateSenhaInicialByVendedor(id).subscribe(
      alterarSenhas => alterarSenha = alterarSenhas,
      error => { console.log("Erro: " + error) },
      () => {
        if (alterarSenha) {
          this.toastr.success("", "Senha resetada com sucesso!");
        }
      }
    );
  }

  getTipoUsuario(vendedor: Vendedor): string {
    if (vendedor == null) {
      return "VEND EXTERNO";
    }

    if (vendedor.is_manager) {
      return "GESTOR";
    }

    if (vendedor.is_master) {
      return "GERENTE";
    }

    if (vendedor.is_master_seller) {
      return "VEND INTERNO";
    }

    if (vendedor.is_diretor) {
      return "DIRETOR";
    }

    if (vendedor.is_financeiro) {
      return "FINANCEIRO";
    }

    return "VEND EXTERNO";
  }

  getTipoUsuarioClass(vendedor: Vendedor): string {
    const tipo = this.getTipoUsuario(vendedor);

    switch (tipo) {
      case "GESTOR":
        return "tag-tipo-gestor";
      case "GERENTE":
        return "tag-tipo-gerente";
      case "VEND INTERNO":
        return "tag-tipo-interno";
      case "DIRETOR":
        return "tag-tipo-diretor";
      case "FINANCEIRO":
        return "tag-tipo-financeiro";
      default:
        return "tag-tipo-externo";
    }
  }

  getAtualizacaoPrecoPromo(vendedor: Vendedor): string {
    if (!(vendedor.versao_app || '').trim()) return '';
    if (vendedor.forcar_atualizaprecosapp === false) return 'SIM';
    if (vendedor.forcar_atualizaprecosapp === true) return 'NÃO';
    return '';
  }

  exportarExcel() {
    const dados = this.vendedores.map(vendedor => {
      return {
        "Id Napis": vendedor.id || "",
        "Nome": vendedor.fullname || "",
        "Equipe": vendedor.nome_equipe || "",
        "Ativo": vendedor.is_active ? "SIM" : "NÃO",
        "Versão App": vendedor.versao_app || "-",
        "Dt Último Login": vendedor.versao_app_ult_login ? this.formatarDataHora(vendedor.versao_app_ult_login) : "-",
        "Atual Preco-Promo": this.getAtualizacaoPrecoPromo(vendedor),
        "Tipo Usuário": this.getTipoUsuario(vendedor),
        "Cod Região": vendedor.codigo_no_erp_do_cliente || "",
        "Cod Vendedor": vendedor.senha_no_erp_do_cliente || "",
        "Email": vendedor.email_real || vendedor.email || "",
        "Gerente": this.getGerente(vendedor)
      };
    });

    this.excelService.exportAsExcelFile(dados, "Vendedores");
  }

  /* Resumo de Licenças */

  abrirResumoLicencas(content: any) {
    this.carregandoResumoLicencas = true;
    this.tipoLicencaExpandido = null;
    this.outrasCobrancasExpandido = false;

    this.modalService.open(content, {
      ariaLabelledBy: "titulo-resumo-licencas",
      size: "lg",
      backdrop: "static"
    });

    this.vendedorService.getResumoLicencas().subscribe(
      resumo => this.resumoLicencas = resumo,
      error => { console.log("Erro: " + error) },
      () => this.carregandoResumoLicencas = false
    );
  }

  alternarTipoLicencaExpandido(tipo: string) {
    this.tipoLicencaExpandido = this.tipoLicencaExpandido == tipo ? null : tipo;
  }

  alternarOutrasCobrancas() {
    this.outrasCobrancasExpandido = !this.outrasCobrancasExpandido;
  }

  getClasseTipoLicenca(tipo: string): string {
    switch (tipo) {
      case "FINANCEIRO":
        return "resumo_licencas_dot_financeiro";
      case "DIRETOR":
        return "resumo_licencas_dot_diretor";
      case "GERENCIAL":
        return "resumo_licencas_dot_gerencial";
      case "COORDENADOR":
        return "resumo_licencas_dot_coordenador";
      case "VENDEDOR INTERNO":
        return "resumo_licencas_dot_interno";
      default:
        return "resumo_licencas_dot_externo";
    }
  }

  getGerente(vendedor: Vendedor): string {
    if (vendedor == null || vendedor.manager_id == null) {
      return "";
    }

    const gerente = this.vendedoresOriginal.find(item => item.id == vendedor.manager_id);
    return gerente != null ? gerente.fullname : vendedor.manager_id.toString();
  }

  private formatarDataHora(data: Date | string): string {
    const valor = new Date(data);

    if (isNaN(valor.getTime())) {
      return "";
    }

    const dia = this.zeroEsquerda(valor.getDate());
    const mes = this.zeroEsquerda(valor.getMonth() + 1);
    const ano = valor.getFullYear();
    const hora = this.zeroEsquerda(valor.getHours());
    const minuto = this.zeroEsquerda(valor.getMinutes());

    return `${dia}/${mes}/${ano} ${hora}:${minuto}`;
  }

  private zeroEsquerda(valor: number): string {
    return valor < 10 ? `0${valor}` : valor.toString();
  }

  /* Dados */

  carregarDados() {
    this.carregando = true;

    this.vendedorService.getVendedorByGuidClienteNapis().subscribe(
      vendedores => this.vendedores = vendedores,
      error => { console.log("Erro: " + error) },
      () => {
        this.vendedoresOriginal = JSON.parse(JSON.stringify(this.vendedores));

        this.carregando = false;
      }
    );
  }

  /* Filtros */

  filtrar() {
    this.enviado = true;

    if (this.formFiltro.valid) {
      const nome = (this.f.nome.value || "").trim().toLowerCase();
      const somenteComVersao = this.f.somenteComVersao.value === true;
      this.filtrado = !!nome || somenteComVersao;
      this.vendedores = this.vendedoresOriginal.filter(vendedor =>
        (!nome || (vendedor.fullname || "").toLowerCase().includes(nome)) &&
        (!somenteComVersao || !!(vendedor.versao_app || "").trim())
      );
      this.aplicarOrdenacaoUltimoLogin();
    }
  }

  removerFiltros() {
    this.vendedores = JSON.parse(JSON.stringify(this.vendedoresOriginal));

    this.formFiltro.reset({ nome: "", somenteComVersao: false });
    this.aplicarOrdenacaoUltimoLogin();

    this.enviado = false;
    this.filtrado = false;
  }

  ordenarPorUltimoLogin() {
    this.ordemUltimoLogin = this.ordemUltimoLogin === 'desc' ? 'asc' : 'desc';
    this.aplicarOrdenacaoUltimoLogin();
  }

  private aplicarOrdenacaoUltimoLogin() {
    if (!this.ordemUltimoLogin) return;
    this.vendedores = [...this.vendedores].sort((a, b) => {
      const dataA = a.versao_app_ult_login ? new Date(a.versao_app_ult_login).getTime() : NaN;
      const dataB = b.versao_app_ult_login ? new Date(b.versao_app_ult_login).getTime() : NaN;
      // Sem login (ou data invalida) fica no fim em ambas as direcoes.
      if (isNaN(dataA) && isNaN(dataB)) return 0;
      if (isNaN(dataA)) return 1;
      if (isNaN(dataB)) return -1;
      return this.ordemUltimoLogin === 'desc' ? dataB - dataA : dataA - dataB;
    });
  }
}
